import React from "react";
import AsyncSelect from "react-select/async";

import {
  FORM_SELECT_STYLES,
  NoIndicatorSeparator,
} from "./styles";

export default function AsyncSelectCustom({ components, styles, ...props }) {
  return (
    <AsyncSelect
      menuPortalTarget={document.body}
      components={{
        ...components,
        IndicatorSeparator: NoIndicatorSeparator,
      }}
      styles={{
        ...FORM_SELECT_STYLES,
        ...styles,
      }}
      {...props}
    />
  );
}
